
/* eslint no-control-regex: 0 */
export default {
  name: 'UtitMixin',
  filters: {
    sn_utilMixin_truncate (value, length, replacementString = '...') {
      if (value !== null && value.length > length) {
        return value.slice(0, length) + replacementString
      }
      return value
    },
    sn_utilMixin_formatPhone (phone) {
      return `(${phone.substr(0, 3)}) ${phone.substr(3, 3)}-${phone.substr(6, 4)}`
    }
  },
  methods: {
    sn_utilMixin_copyToClipBoard (value) {
      const el = document.createElement('textarea')
      el.value = value
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
    },
    sn_utilMixin_specialCharacterCheck (value) {
      const pattern = /^[\x00-\x7F]*$/
      return pattern.test(value) || 'Invalid characters'
    },
    sn_utilMixin_numbersOnlyCheck (value) {
      const pattern = /^(\d)*$/
      return pattern.test(value) || 'Please enter a valid number'
    },
    sn_utilMixin_deformatPhone (phone) {
      return phone.replace(/[^0-9]/g, '')
    },
    sn_utilMixin_isDarkColor (hexColor) {
      // found at
      // https://stackoverflow.com/questions/12043187/how-to-check-if-hex-color-is-too-black

      const color = hexColor
      let c = color

      if (c[0] === '#') { c = color.substring(1) } // strip #

      const rgb = parseInt(c, 16) // convert rrggbb to decimal
      const r = (rgb >> 16) & 0xff // extract red
      const g = (rgb >> 8) & 0xff // extract green
      const b = (rgb >> 0) & 0xff // extract blue

      const luma = 0.2126 * r + 0.7152 * g + 0.0722 * b // per ITU-R BT.709

      if (luma < 128) { return true }

      return false
    }
  }
}
